import { colorsNewReverse, colorsReverse } from "./lyneUphelpers"
import { colorsReverseLyneFit } from "./lyneFitHelper"
import { colorsReverseLyneHome } from "./lyneHomeHelper"
import moment from "moment-business-days"

export const productTitle = (title, variant, locale) => {
  let newTitle = ""
  let variantPrice = variant.price.amount ? variant.price.amount : variant.price
  variant = variant.selectedOptions
  if (locale === "en") {
    if (title === "LyneUp") {
      if (variant.find(item => item.name === "Gender").value === "Female") {
        newTitle = newTitle + "Lyne up – everyday vest women –"
      } else {
        newTitle = newTitle + "Lyne up – everyday vest men –"
      }
    } else if (title === "LyneHome") {
      if (variant.find(item => item.name === "Gender").value === "Female") {
        newTitle = newTitle + "Lyne home women – vest for at home –"
      } else {
        newTitle = newTitle + "Lyne home men – vest for at home –"
      }
    } else if (title === "LyneFit") {
      if (variant.find(item => item.name === "Gender").value === "Female") {
        newTitle = newTitle + "Lyne fit – sports t-shirt women –"
      } else {
        newTitle = newTitle + "Lyne fit – sports t-shirt men –"
      }
    } else if (title === "Loop") {
      newTitle = newTitle + "Loop - self-massage accessory"
    } else if (title.includes("gift-card")) {
      if (title.includes("lyneup")) newTitle = newTitle + "E-gift card LyneUp"
      else if (title.includes("lynefit"))
        newTitle = newTitle + "E-gift card LyneFit"
      else if (title.includes("lynepro"))
        newTitle = newTitle + "E-gift card LynePro"
      else if (title.includes("loop-card"))
        newTitle = newTitle + "E-gift card Combo"
      else if (title.includes("Loop"))
        newTitle = newTitle + "Loop - self-massage accessory"
      else newTitle = newTitle + "E-gift card"
    } else if (
      title.includes("E-carte cadeau") ||
      title.includes("E-carte cadeau offerte") ||
      title.includes("E-CARTE")
    ) {
      newTitle = newTitle + "E-carte cadeau PERCKO de"
    } else if (title === "Matelas") {
      newTitle = newTitle + "Matelas hybride premium qui soulage le dos –"
    } else if (title === "1 Matelas + Oreiller") {
      newTitle = newTitle + "Pack : 1 matelas hybride premium –"
    } else if (title === "Matelas Mousse") {
      newTitle =
        newTitle + "Matelas mousse mémoire de forme qui soulage le dos –"
    } else if (title === "1 Matelas Mousse + Oreiller") {
      newTitle = newTitle + "Pack : 1 matelas mousse mémoire de forme –"
    } else if (title === "Matelas signature") {
      newTitle = newTitle + "Matelas signature –"
    } else if (title === "Protège-matelas") {
      newTitle = newTitle + "Protège-matelas –"
    } else if (title === "Oreiller") {
      newTitle =
        newTitle + "Oreiller universel, l'allié ergonomique pour le dos "
    } else if (title === "Oreiller dorsal+") {
      newTitle = newTitle + "Oreiller dorsal+, l'allié ergonomique pour le dos"
    } else if (title === "Oreiller plat") {
      newTitle = newTitle + "Oreiller plat, l'allié ergonomique pour le dos"
    } else if (title === "Taie d'oreiller universel") {
      newTitle = newTitle + "Taie d'oreiller universel "
    } else if (title === "Taie d'oreiller dorsal+") {
      newTitle = newTitle + "Taie d'oreiller dorsal+"
    } else if (title === "Taie d'oreiller plat") {
      newTitle = newTitle + "Taie d'oreiller plat"
    } else if (title === "Sommier Original") {
      newTitle = newTitle + "Sommier zoné - original –"
    } else if (title === "Sommier zoné - coffre - effet chêne blanchi") {
      newTitle = newTitle + "Sommier zoné - coffre - effet chêne blanchi –"
    } else if (
      title === "Sommier zoné - coffre - hêtre bois massif avec tête de lit"
    ) {
      newTitle =
        newTitle +
        "Sommier zoné - coffre - hêtre bois massif avec tête de lit –"
    } else if (
      title === "Sommier zoné - coffre - chêne bois massif avec tête de lit"
    ) {
      newTitle =
        newTitle +
        "Sommier zoné - coffre - chêne bois massif avec tête de lit –"
    } else if (
      title === "Sommier zoné - coffre - hêtre bois massif sans tête de lit"
    ) {
      newTitle =
        newTitle +
        "Sommier zoné - coffre - hêtre bois massif sans tête de lit –"
    } else if (
      title === "Sommier zoné - coffre - chêne bois massif sans tête de lit"
    ) {
      newTitle =
        newTitle +
        "Sommier zoné - coffre - chêne bois massif sans tête de lit –"
    } else if (title === "Sommier Bois Massif") {
      newTitle = newTitle + "Sommier zoné - bois massif –"
    } else if (title === "Sommier zoné - électrique") {
      newTitle = newTitle + "Sommier zoné - électrique –"
    } else if (title === "Sommier zoné - original tapissier") {
      newTitle = newTitle + "Sommier zoné - tapissier –"
    } else if (title === "Chaise ergonomique") {
      newTitle = newTitle + "Chaise de bureau ergonomique"
    } else if (title === "Surmatelas") {
      newTitle = newTitle + "Surmatelas –"
    } else if (title === "T-SHIRT DISCRET - HOMME") {
      newTitle = newTitle + "T-shirt discret - Homme –"
    } else if (title === "T-SHIRT DISCRET - FEMME") {
      newTitle = newTitle + "T-shirt discret - Femme –"
    } else if (title === "T-SHIRT DE SPORT - HOMME") {
      newTitle = newTitle + "T-shirt de sport - Homme –"
    } else if (title === "T-SHIRT DE SPORT - FEMME") {
      newTitle = newTitle + "T-shirt de sport - Femme –"
    } else if (title === "GILET PRATIQUE - HOMME") {
      newTitle = newTitle + "Gilet pratique - Homme –"
    } else if (title === "GILET PRATIQUE - FEMME") {
      newTitle = newTitle + "Gilet pratique - Femme –"
    }
  } else if (locale === "de") {
    if (title === "LyneUp") {
      if (variant.find(item => item.name === "Gender").value === "Female") {
        newTitle = newTitle + "Lyne up – unterhemd damen –"
      } else {
        newTitle = newTitle + "Lyne up – unterhemd herren –"
      }
    } else if (title === "LyneHome") {
      if (variant.find(item => item.name === "Gender").value === "Female") {
        newTitle = newTitle + "Lyne home männer – weste für zuhause –"
      } else {
        newTitle = newTitle + "Lyne home frauen – weste für zuhause –"
      }
    } else if (title === "LyneFit") {
      if (variant.find(item => item.name === "Gender").value === "Female") {
        newTitle = newTitle + "Lyne fit – sportshirt damen –"
      } else {
        newTitle = newTitle + "Lyne fit – sportshirt herren –"
      }
    } else if (title === "Loop") {
      newTitle = newTitle + "Loop - self-massage accessory"
    } else if (title.includes("gift-card")) {
      if (title.includes("lyneup")) newTitle = newTitle + "E-gift card LyneUp"
      else if (title.includes("lynefit"))
        newTitle = newTitle + "E-gift card LyneFit"
      else if (title.includes("lynepro"))
        newTitle = newTitle + "E-gift card LynePro"
      else if (title.includes("loop-card"))
        newTitle = newTitle + "E-gift card Combo"
      else if (title.includes("Loop"))
        newTitle = newTitle + "Loop - self-massage accessory"
      else newTitle = newTitle + "E-gift card"
    } else if (
      title.includes("E-carte cadeau") ||
      title.includes("E-carte cadeau offerte") ||
      title.includes("E-CARTE")
    ) {
      newTitle = newTitle + "E-carte cadeau PERCKO de"
    } else if (title === "Matelas") {
      newTitle = newTitle + "Matelas hybride premium qui soulage le dos –"
    } else if (title === "1 Matelas + Oreiller") {
      newTitle = newTitle + "Pack : 1 matelas hybride premium –"
    } else if (title === "Matelas Mousse") {
      newTitle =
        newTitle + "Matelas mousse mémoire de forme qui soulage le dos –"
    } else if (title === "1 Matelas Mousse + Oreiller") {
      newTitle = newTitle + "Pack : 1 matelas mousse mémoire de forme –"
    } else if (title === "Matelas signature") {
      newTitle = newTitle + "Matelas signature –"
    } else if (title === "Protège-matelas") {
      newTitle = newTitle + "Protège-matelas –"
    } else if (title === "Oreiller") {
      newTitle =
        newTitle + "Oreiller universel, l'allié ergonomique pour le dos "
    } else if (title === "Oreiller dorsal+") {
      newTitle = newTitle + "Oreiller dorsal+, l'allié ergonomique pour le dos"
    } else if (title === "Oreiller plat") {
      newTitle = newTitle + "Oreiller plat, l'allié ergonomique pour le dos"
    } else if (title === "Taie d'oreiller universel") {
      newTitle = newTitle + "Taie d'oreiller universel "
    } else if (title === "Taie d'oreiller dorsal+") {
      newTitle = newTitle + "Taie d'oreiller dorsal+"
    } else if (title === "Taie d'oreiller plat") {
      newTitle = newTitle + "Taie d'oreiller plat"
    } else if (title === "Sommier Original") {
      newTitle = newTitle + "Sommier zoné - original –"
    } else if (title === "Sommier zoné - coffre - effet chêne blanchi") {
      newTitle = newTitle + "Sommier zoné - coffre - effet chêne blanchi –"
    } else if (
      title === "Sommier zoné - coffre - hêtre bois massif avec tête de lit"
    ) {
      newTitle =
        newTitle +
        "Sommier zoné - coffre - hêtre bois massif avec tête de lit –"
    } else if (
      title === "Sommier zoné - coffre - chêne bois massif avec tête de lit"
    ) {
      newTitle =
        newTitle +
        "Sommier zoné - coffre - chêne bois massif avec tête de lit –"
    } else if (
      title === "Sommier zoné - coffre - hêtre bois massif sans tête de lit"
    ) {
      newTitle =
        newTitle +
        "Sommier zoné - coffre - hêtre bois massif sans tête de lit –"
    } else if (
      title === "Sommier zoné - coffre - chêne bois massif sans tête de lit"
    ) {
      newTitle =
        newTitle +
        "Sommier zoné - coffre - chêne bois massif sans tête de lit –"
    } else if (title === "Sommier Bois Massif") {
      newTitle = newTitle + "Sommier zoné - bois massif –"
    } else if (title === "Sommier zoné - électrique") {
      newTitle = newTitle + "Sommier zoné - électrique –"
    } else if (title === "Sommier zoné - original tapissier") {
      newTitle = newTitle + "Sommier zoné - tapissier –"
    } else if (title === "Chaise ergonomique") {
      newTitle = newTitle + "Chaise de bureau ergonomique"
    } else if (title === "Surmatelas") {
      newTitle = newTitle + "Surmatelas –"
    } else if (title === "T-SHIRT DISCRET - HOMME") {
      newTitle = newTitle + "T-shirt discret - Homme –"
    } else if (title === "T-SHIRT DISCRET - FEMME") {
      newTitle = newTitle + "T-shirt discret - Femme –"
    } else if (title === "T-SHIRT DE SPORT - HOMME") {
      newTitle = newTitle + "T-shirt de sport - Homme –"
    } else if (title === "T-SHIRT DE SPORT - FEMME") {
      newTitle = newTitle + "T-shirt de sport - Femme –"
    } else if (title === "GILET PRATIQUE - HOMME") {
      newTitle = newTitle + "Gilet pratique - Homme –"
    } else if (title === "GILET PRATIQUE - FEMME") {
      newTitle = newTitle + "Gilet pratique - Femme –"
    }
  } else if (locale === "es") {
    if (title === "LyneUp") {
      if (variant.find(item => item.name === "Gender").value === "Female") {
        newTitle = newTitle + "Lyne up – camiseta interior mujer –"
      } else {
        newTitle = newTitle + "Lyne up – camiseta interior hombre –"
      }
    } else if (title === "LyneHome") {
      if (variant.find(item => item.name === "Gender").value === "Female") {
        newTitle = newTitle + "Lyne home mujer – chaleco para la casa –"
      } else {
        newTitle = newTitle + "Lyne home hombre – chaleco para la casa –"
      }
    } else if (title === "LyneFit") {
      if (variant.find(item => item.name === "Gender").value === "Female") {
        newTitle = newTitle + "Lyne fit – camiseta deportiva mujer –"
      } else {
        newTitle = newTitle + "Lyne fit – camiseta deportiva hombre –"
      }
    } else if (title === "Loop") {
      newTitle = newTitle + "Loop - self-massage accessory"
    } else if (title.includes("gift-card")) {
      if (title.includes("lyneup")) newTitle = newTitle + "E-gift card LyneUp"
      else if (title.includes("lynefit"))
        newTitle = newTitle + "E-gift card LyneFit"
      else if (title.includes("lynepro"))
        newTitle = newTitle + "E-gift card LynePro"
      else if (title.includes("loop-card"))
        newTitle = newTitle + "E-gift card Combo"
      else if (title.includes("Loop"))
        newTitle = newTitle + "Loop - self-massage accessory"
      else newTitle = newTitle + "E-gift card"
    } else if (
      title.includes("E-carte cadeau") ||
      title.includes("E-carte cadeau offerte") ||
      title.includes("E-CARTE")
    ) {
      newTitle = newTitle + "E-carte cadeau PERCKO de"
    } else if (title === "Matelas") {
      newTitle = newTitle + "Matelas hybride premium qui soulage le dos –"
    } else if (title === "1 Matelas + Oreiller") {
      newTitle = newTitle + "Pack : 1 matelas hybride premium –"
    } else if (title === "Matelas Mousse") {
      newTitle =
        newTitle + "Matelas mousse mémoire de forme qui soulage le dos –"
    } else if (title === "1 Matelas Mousse + Oreiller") {
      newTitle = newTitle + "Pack : 1 matelas mousse mémoire de forme –"
    } else if (title === "Matelas signature") {
      newTitle = newTitle + "Matelas signature –"
    } else if (title === "Protège-matelas") {
      newTitle = newTitle + "Protège-matelas –"
    } else if (title === "Oreiller") {
      newTitle =
        newTitle + "Oreiller universel, l'allié ergonomique pour le dos "
    } else if (title === "Oreiller dorsal+") {
      newTitle = newTitle + "Oreiller dorsal+, l'allié ergonomique pour le dos"
    } else if (title === "Oreiller plat") {
      newTitle = newTitle + "Oreiller plat, l'allié ergonomique pour le dos"
    } else if (title === "Taie d'oreiller universel") {
      newTitle = newTitle + "Taie d'oreiller universel "
    } else if (title === "Taie d'oreiller dorsal+") {
      newTitle = newTitle + "Taie d'oreiller dorsal+"
    } else if (title === "Taie d'oreiller plat") {
      newTitle = newTitle + "Taie d'oreiller plat"
    } else if (title === "Sommier Original") {
      newTitle = newTitle + "Sommier zoné - original –"
    } else if (title === "Sommier zoné - coffre - effet chêne blanchi") {
      newTitle = newTitle + "Sommier zoné - coffre - effet chêne blanchi –"
    } else if (
      title === "Sommier zoné - coffre - hêtre bois massif avec tête de lit"
    ) {
      newTitle =
        newTitle +
        "Sommier zoné - coffre - hêtre bois massif avec tête de lit –"
    } else if (
      title === "Sommier zoné - coffre - chêne bois massif avec tête de lit"
    ) {
      newTitle =
        newTitle +
        "Sommier zoné - coffre - chêne bois massif avec tête de lit –"
    } else if (
      title === "Sommier zoné - coffre - hêtre bois massif sans tête de lit"
    ) {
      newTitle =
        newTitle +
        "Sommier zoné - coffre - hêtre bois massif sans tête de lit –"
    } else if (
      title === "Sommier zoné - coffre - chêne bois massif sans tête de lit"
    ) {
      newTitle =
        newTitle +
        "Sommier zoné - coffre - chêne bois massif sans tête de lit –"
    } else if (title === "Sommier Bois Massif") {
      newTitle = newTitle + "Sommier zoné - bois massif –"
    } else if (title === "Sommier zoné - électrique") {
      newTitle = newTitle + "Sommier zoné - électrique –"
    } else if (title === "Sommier zoné - original tapissier") {
      newTitle = newTitle + "Sommier zoné - tapissier –"
    } else if (title === "Chaise ergonomique") {
      newTitle = newTitle + "Chaise de bureau ergonomique"
    } else if (title === "Surmatelas") {
      newTitle = newTitle + "Surmatelas –"
    } else if (title === "T-SHIRT DISCRET - HOMME") {
      newTitle = newTitle + "T-shirt discret - Homme –"
    } else if (title === "T-SHIRT DISCRET - FEMME") {
      newTitle = newTitle + "T-shirt discret - Femme –"
    } else if (title === "T-SHIRT DE SPORT - HOMME") {
      newTitle = newTitle + "T-shirt de sport - Homme –"
    } else if (title === "T-SHIRT DE SPORT - FEMME") {
      newTitle = newTitle + "T-shirt de sport - Femme –"
    } else if (title === "GILET PRATIQUE - HOMME") {
      newTitle = newTitle + "Gilet pratique - Homme –"
    } else if (title === "GILET PRATIQUE - FEMME") {
      newTitle = newTitle + "Gilet pratique - Femme –"
    }
  } else {
    if (title === "LyneUp") {
      if (variant.find(item => item.name === "Gender").value === "Female") {
        newTitle =
          newTitle + "Lyne up femme – sous-vêtement pour le quotidien –"
      } else {
        newTitle =
          newTitle + "Lyne up homme – sous-vêtement pour le quotidien –"
      }
    } else if (title === "LyneHome") {
      if (variant.find(item => item.name === "Gender").value === "Female") {
        newTitle = newTitle + "Lyne home femme – gilet pour la maison –"
      } else {
        newTitle = newTitle + "Lyne home homme – gilet pour la maison –"
      }
    } else if (title === "LyneFit") {
      if (variant.find(item => item.name === "Gender").value === "Female") {
        newTitle = newTitle + "Lyne fit femme – t-shirt pour le sport –"
      } else {
        newTitle = newTitle + "Lyne fit homme – t-shirt pour le sport –"
      }
    } else if (title === "Patches") {
      newTitle = newTitle + "Rrcharge patchs adhésifs"
    } else if (title === "Loop") {
      newTitle = newTitle + "Loop - accessoire d'automassage"
    } else if (title.includes("gift-card")) {
      if (title.includes("lyneup")) newTitle = newTitle + "E-gift card LyneUp"
      else if (title.includes("lynefit"))
        newTitle = newTitle + "E-gift card LyneFit"
      else if (title.includes("lynepro"))
        newTitle = newTitle + "E-gift card LynePro"
      else if (title.includes("loop-card"))
        newTitle = newTitle + "E-gift card Combo"
      else if (title.includes("Loop"))
        newTitle = newTitle + "Loop - accessoire d'automassage"
      else newTitle = newTitle + "E-carte cadeau"
    } else if (
      title.includes("E-carte cadeau") ||
      title.includes("E-carte cadeau offerte") ||
      title.includes("E-CARTE")
    ) {
      newTitle = newTitle + "E-carte cadeau PERCKO de"
    } else if (title === "Matelas") {
      newTitle = newTitle + "Matelas hybride premium qui soulage le dos –"
    } else if (title === "1 Matelas + Oreiller") {
      newTitle = newTitle + "Pack : 1 matelas hybride premium –"
    } else if (title === "Matelas Mousse") {
      newTitle =
        newTitle + "Matelas mousse mémoire de forme qui soulage le dos –"
    } else if (title === "1 Matelas Mousse + Oreiller") {
      newTitle = newTitle + "Pack : 1 matelas mousse mémoire de forme –"
    } else if (title === "Matelas signature") {
      newTitle = newTitle + "Matelas signature –"
    } else if (title === "Protège-matelas") {
      newTitle = newTitle + "Protège-matelas –"
    } else if (title === "Oreiller") {
      newTitle =
        newTitle + "Oreiller universel, l'allié ergonomique pour le dos "
    } else if (title === "Oreiller dorsal+") {
      newTitle = newTitle + "Oreiller dorsal+, l'allié ergonomique pour le dos"
    } else if (title === "Oreiller plat") {
      newTitle = newTitle + "Oreiller plat, l'allié ergonomique pour le dos"
    } else if (title === "Taie d'oreiller universel") {
      newTitle = newTitle + "Taie d'oreiller universel "
    } else if (title === "Taie d'oreiller dorsal+") {
      newTitle = newTitle + "Taie d'oreiller dorsal+"
    } else if (title === "Taie d'oreiller plat") {
      newTitle = newTitle + "Taie d'oreiller plat"
    } else if (title === "Sommier Original") {
      newTitle = newTitle + "Sommier zoné - original –"
    } else if (title === "Sommier zoné - coffre - effet chêne blanchi") {
      newTitle = newTitle + "Sommier zoné - coffre - effet chêne blanchi –"
    } else if (
      title === "Sommier zoné - coffre - hêtre bois massif avec tête de lit"
    ) {
      newTitle =
        newTitle +
        "Sommier zoné - coffre - hêtre bois massif avec tête de lit –"
    } else if (
      title === "Sommier zoné - coffre - chêne bois massif avec tête de lit"
    ) {
      newTitle =
        newTitle +
        "Sommier zoné - coffre - chêne bois massif avec tête de lit –"
    } else if (
      title === "Sommier zoné - coffre - hêtre bois massif sans tête de lit" ||
      title === "Sommier Coffre bois massif hêtre sans tête"
    ) {
      newTitle =
        newTitle +
        "Sommier zoné - coffre - hêtre bois massif sans tête de lit –"
    } else if (
      title === "Sommier zoné - coffre - chêne bois massif sans tête de lit" ||
      title === "Sommier Coffre bois massif chêne sans tête"
    ) {
      newTitle =
        newTitle +
        "Sommier zoné - coffre - chêne bois massif sans tête de lit –"
    } else if (title === "Sommier Bois Massif") {
      newTitle = newTitle + "Sommier zoné - bois massif –"
    } else if (title === "Sommier zoné - électrique") {
      newTitle = newTitle + "Sommier zoné - électrique –"
    } else if (title === "Sommier zoné - original tapissier") {
      newTitle = newTitle + "Sommier zoné - tapissier –"
    } else if (title === "Chaise ergonomique") {
      newTitle = newTitle + "Chaise de bureau ergonomique"
    } else if (title === "Surmatelas") {
      newTitle = newTitle + "Surmatelas –"
    } else if (title === "T-SHIRT DISCRET - HOMME") {
      newTitle = newTitle + "T-shirt discret - Homme –"
    } else if (title === "T-SHIRT DISCRET - FEMME") {
      newTitle = newTitle + "T-shirt discret - Femme –"
    } else if (title === "T-SHIRT DE SPORT - HOMME") {
      newTitle = newTitle + "T-shirt de sport - Homme –"
    } else if (title === "T-SHIRT DE SPORT - FEMME") {
      newTitle = newTitle + "T-shirt de sport - Femme –"
    } else if (title === "GILET PRATIQUE - HOMME") {
      newTitle = newTitle + "Gilet pratique - Homme –"
    } else if (title === "GILET PRATIQUE - FEMME") {
      newTitle = newTitle + "Gilet pratique - Femme –"
    } else if (title === "Soutien-gorge") {
      newTitle = newTitle + "Soutien-gorge –"
    }
  }

  if (title === "LyneUp") {
    newTitle =
      newTitle +
      " " +
      colorsReverse[locale][
        variant?.find(item => item?.name === "Color")?.value
      ] +
      " , " +
      variant.find(item => item.name === "Size").value
  } else if (title === "LyneHome") {
    newTitle =
      newTitle +
      " " +
      colorsReverseLyneHome[locale]["BLUE"] +
      " , " +
      variant.find(item => item.name === "Size").value
  } else if (title === "LyneFit") {
    newTitle =
      newTitle +
      " " +
      colorsReverseLyneFit[locale][
        variant?.find(item => item?.name === "Color")?.value
      ] +
      " , " +
      variant.find(item => item.name === "Size").value
  } else if (
    title === "1 Matelas + Oreiller" ||
    title === "1 Matelas Mousse + Oreiller"
  ) {
    newTitle =
      newTitle +
      " " +
      variant.find(item => item.name === "Size").value +
      " " +
      (Number(variantPrice).toFixed(0) > 900
        ? "+ 2 oreillers universels"
        : "+ 1 oreiller universel")
  } else if (
    title === "Matelas" ||
    title === "Matelas Mousse" ||
    title === "Matelas signature" ||
    title === "Protège-matelas" ||
    title === "Surmatelas" ||
    title === "Sommier Original" ||
    title === "Sommier zoné - coffre - effet chêne blanchi" ||
    title === "Sommier zoné - coffre - hêtre bois massif avec tête de lit" ||
    title === "Sommier zoné - coffre - chêne bois massif avec tête de lit" ||
    title === "Sommier zoné - coffre - chêne bois massif sans tête de lit" ||
    title === "Sommier zoné - coffre - hêtre bois massif sans tête de lit" ||
    title === "Sommier Coffre bois massif chêne sans tête" ||
    title === "Sommier Coffre bois massif hêtre sans tête" ||
    title === "Sommier Bois Massif" ||
    title === "Sommier zoné - électrique" ||
    title === "Sommier zoné - original tapissier"
  ) {
    newTitle = newTitle + " " + variant.find(item => item.name === "Size").value
  } else if (
    title === "T-SHIRT DISCRET - HOMME" ||
    title === "GILET PRATIQUE - HOMME" ||
    title === "GILET PRATIQUE - FEMME"
  ) {
    newTitle =
      newTitle +
      " " +
      colorsNewReverse[locale]?.[
        variant?.find(item => item?.name === "Color")?.value
      ] +
      " - " +
      variant.find(item => item.name === "Size").value
  } else if (
    title === "T-SHIRT DE SPORT - HOMME" ||
    title === "T-SHIRT DE SPORT - FEMME"
  ) {
    newTitle =
      newTitle +
      " " +
      (variant?.find(item => item?.name === "Color")?.value === "Noir"
        ? "Noir respirant"
        : colorsNewReverse[locale]?.[
            variant?.find(item => item?.name === "Color")?.value
          ]) +
      " - " +
      variant.find(item => item.name === "Size").value
  } else if (title === "T-SHIRT DISCRET - FEMME") {
    newTitle =
      newTitle +
      " " +
      colorsNewReverse[locale]?.[
        variant?.find(item => item?.name === "Color")?.value
      ] +
      " - " +
      "Col " +
      variant.find(item => item.name === "Collar").value +
      " - " +
      variant.find(item => item.name === "Size").value
  } else if (title === "Soutien-gorge") {
    newTitle =
      newTitle +
      " " +
      colorsNewReverse[locale]?.[
        variant?.find(item => item?.name === "Color")?.value
      ] +
      " - " +
      variant.find(item => item.name === "Size").value
  } else if (
    title.includes("E-carte cadeau") ||
    title.includes("E-carte cadeau offerte") ||
    title.includes("E-CARTE")
  ) {
    newTitle =
      newTitle + " " + variant.find(item => item.name === "Montant").value
  }
  return newTitle
}

export const linkCartProduct = (title, variant, locale, offerExclusif) => {
  let link = ""
  variant = variant.selectedOptions
  if (title === "LyneUp") {
    link =
      `/shop/${
        locale === "fr"
          ? "lyneup-test"
          : locale === "en"
          ? "lyneup-test"
          : "lyneup-2b"
      }` +
      "/?Gender=" +
      variant.find(item => item.name === "Gender").value +
      "&Color=" +
      variant.find(item => item.name === "Color").value +
      "&Size=" +
      variant.find(item => item.name === "Size").value
  } else if (title === "LyneFit") {
    link =
      "/shop/lynefit/?Gender=" +
      variant.find(item => item.name === "Gender").value +
      "&Color=" +
      variant?.find(item => item?.name === "Color")?.value +
      "&Size=" +
      variant.find(item => item.name === "Size").value
  } else if (title === "LyneHome") {
    link =
      "/shop/lynehome/?Gender=" +
      variant.find(item => item.name === "Gender").value +
      "&Size=" +
      variant.find(item => item.name === "Size").value
  } else if (title === "Loop") {
    link = "/shop/loop/"
  } else if (title.includes("gift-card")) {
    link = `${locale === "fr" ? "/idee-cadeau/" : "/gifts/"}`
  } else if (title === "Matelas signature") {
    link =
      "/shop/" +
      `${
        offerExclusif === "top-exclu" || offerExclusif === "top-exclu-3x4uc"
          ? "matelas-signature-haut-de-gamme-exclusif"
          : "matelas-signature-haut-de-gamme"
      }` +
      "/?Size=" +
      variant.find(item => item.name === "Size").value
  } else if (title === "Matelas" || title === "1 Matelas + Oreiller") {
    link =
      "/shop/" +
      `${
        offerExclusif === "top-exclu" || offerExclusif === "top-exclu-3x4uc"
          ? "matelas-hybride-ressorts-ensaches-exclusif"
          : "matelas-hybride-ressorts-ensaches"
      }` +
      "/?Size=" +
      variant.find(item => item.name === "Size").value +
      `&${title === "1 Matelas + Oreiller" ? "Pack=1" : "Seul=1"}`
  } else if (
    title === "Matelas Mousse" ||
    title === "1 Matelas Mousse + Oreiller"
  ) {
    link =
      "/shop/" +
      `${
        offerExclusif === "top-exclu" || offerExclusif === "top-exclu-3x4uc"
          ? "matelas-mousse-memoire-de-forme-exclusif"
          : "matelas-mousse-memoire-de-forme"
      }` +
      "/?Size=" +
      variant.find(item => item.name === "Size").value +
      `&${title === "1 Matelas Mousse + Oreiller" ? "Pack=1" : "Seul=1"}`
  } else if (title === "Protège-matelas") {
    link =
      "/shop/" +
      `${
        offerExclusif === "top-exclu" || offerExclusif === "top-exclu-3x4uc"
          ? "matelas-hybride-ressorts-ensaches-exclusif"
          : "matelas-hybride-ressorts-ensaches"
      }` +
      "/?Size=" +
      variant.find(item => item.name === "Size").value +
      "&Protegematelas=1#Protegematelas"
  } else if (
    title === "Oreiller" ||
    title === "Oreiller dorsal+" ||
    title === "Oreiller plat" ||
    title === "Taie d'oreiller universel" ||
    title === "Taie d'oreiller dorsal+" ||
    title === "Taie d'oreiller plat"
  ) {
    link =
      "/shop/" +
      `${
        offerExclusif === "top-exclu" || offerExclusif === "top-exclu-3x4uc"
          ? "oreillers-ergonomiques-exclusif"
          : "oreillers-ergonomiques"
      }` +
      `/?${
        title === "Taie d'oreiller plat"
          ? "Taie_plat=1"
          : title === "Taie d'oreiller dorsal+"
          ? "Taie_dorsalplus=1"
          : title === "Taie d'oreiller universel"
          ? "Taie_universel=1"
          : title === "Oreiller plat"
          ? "Oreiller_plat=1"
          : title === "Oreiller dorsal+"
          ? "Oreiller_dorsalplus=1"
          : "Oreiller_universel=1"
      }`
  } else if (title === "Sommier Original") {
    link =
      "/shop/" +
      `${
        offerExclusif === "top-exclu" || offerExclusif === "top-exclu-3x4uc"
          ? "sommier-zone-original-exclusif"
          : "sommier-zone-original"
      }` +
      "/?Size=" +
      variant.find(item => item.name === "Size").value
  } else if (
    title === "Sommier zoné - coffre - effet chêne blanchi" ||
    title === "Sommier zoné - coffre - chêne bois massif avec tête de lit" ||
    title === "Sommier zoné - coffre - hêtre bois massif avec tête de lit" ||
    title === "Sommier zoné - coffre - chêne bois massif sans tête de lit" ||
    title === "Sommier zoné - coffre - hêtre bois massif sans tête de lit" ||
    title === "Sommier Coffre bois massif chêne sans tête" ||
    title === "Sommier Coffre bois massif hêtre sans tête"
  ) {
    link =
      "/shop/" +
      `${
        offerExclusif === "top-exclu" || offerExclusif === "top-exclu-3x4uc"
          ? "sommier-zone-coffre-exclusif"
          : "sommier-zone-coffre"
      }` +
      "/?Size=" +
      variant.find(item => item.name === "Size").value +
      `&Finition=${
        title === "Sommier zoné - coffre - chêne bois massif avec tête de lit"
          ? "Chene_massif_et_tete"
          : title ===
            "Sommier zoné - coffre - hêtre bois massif avec tête de lit"
          ? "Hetre_massif_et_tete"
          : title ===
              "Sommier zoné - coffre - chêne bois massif sans tête de lit" ||
            title === "Sommier Coffre bois massif chêne sans tête"
          ? "Chene_massif_sans_tete"
          : title ===
              "Sommier zoné - coffre - hêtre bois massif sans tête de lit" ||
            title === "Sommier Coffre bois massif hêtre sans tête"
          ? "Hetre_massif_sans_tete"
          : "Effet_chene_blanchi"
      }`
  } else if (title === "Sommier Bois Massif") {
    link =
      "/shop/" +
      `${
        offerExclusif === "top-exclu" || offerExclusif === "top-exclu-3x4uc"
          ? "sommier-zone-bois-massif-exclusif"
          : "sommier-zone-bois-massif"
      }` +
      "/?Size=" +
      variant.find(item => item.name === "Size").value
  } else if (title === "Sommier zoné - électrique") {
    link =
      "/shop/" +
      `${
        offerExclusif === "top-exclu" || offerExclusif === "top-exclu-3x4uc"
          ? "lit-electrique-exclusif"
          : "lit-electrique"
      }` +
      "/?Size=" +
      variant.find(item => item.name === "Size").value
  } else if (title === "Sommier zoné - original tapissier") {
    link =
      "/shop/" +
      `${
        offerExclusif === "top-exclu" || offerExclusif === "top-exclu-3x4uc"
          ? "sommier-zone-tapissier-exclusif"
          : "sommier-zone-tapissier"
      }` +
      "/?Size=" +
      variant.find(item => item.name === "Size").value
  } else if (title === "Chaise ergonomique") {
    link =
      "/shop/" +
      `${
        offerExclusif === "top-exclu" || offerExclusif === "top-exclu-3x4uc"
          ? "chaise-bureau-ergonomique-exclusif"
          : "chaise-bureau-ergonomique"
      }`
  } else if (title === "Surmatelas") {
    link =
      "/shop/" +
      `${
        offerExclusif === "top-exclu" || offerExclusif === "top-exclu-3x4uc"
          ? "surmatelas-exclusif"
          : "surmatelas"
      }` +
      "/?Size=" +
      variant.find(item => item.name === "Size").value
  } else if (
    title === "T-SHIRT DISCRET - HOMME" ||
    title === "T-SHIRT DISCRET - FEMME" ||
    title === "T-SHIRT DE SPORT - HOMME" ||
    title === "T-SHIRT DE SPORT - FEMME" ||
    title === "GILET PRATIQUE - HOMME" ||
    title === "GILET PRATIQUE - FEMME"
  ) {
    link =
      `/shop/${
        offerExclusif === "top-exclu" || offerExclusif === "top-exclu-3x4uc"
          ? "solutions-textiles-exclusif"
          : "solutions-textiles"
      }/` +
      `${
        title.includes("GILET")
          ? "gilet-pratique"
          : title.includes("SPORT")
          ? "tshirt-sport"
          : "tshirt-discret"
      }` +
      "/?Gender=" +
      `${title.includes("HOMME") ? "Male" : "Female"}` +
      "&Color=" +
      variant?.find(item => item?.name === "Color")?.value +
      "&Collar=" +
      variant.find(item => item.name === "Collar").value +
      "&Size=" +
      variant.find(item => item.name === "Size").value
  } else if (title === "Soutien-gorge") {
    link =
      `/shop/${
        offerExclusif === "top-exclu" || offerExclusif === "top-exclu-3x4uc"
          ? "solutions-textiles-exclusif/soutien-gorge-exclusif"
          : "solutions-textiles/soutien-gorge"
      }/?Gender=Female&Color=` +
      variant?.find(item => item?.name === "Color")?.value +
      "&Size=" +
      variant.find(item => item.name === "Size").value
  } else if (title.includes("E-carte cadeau")) {
    link =
      "/" +
      `${
        process &&
        process.env &&
        process.env.GATSBY_ACTIVE_ENV === "eur" &&
        locale === "fr"
          ? `e-carte-cadeau?Montant=${variant
              .find(item => item.name === "Montant")
              .value.slice(0, -1)}`
          : locale === "fr"
          ? "idee-cadeau"
          : "gifts"
      }`
  }

  return link
}

export const returnCartImage = lang => {
  let images = {
    eur: {
      en: "https://static.percko.com/uploads/2b57d27f-0b45-4b09-a178-6a0856fddb65.png",
      fr: "https://static.percko.com/uploads/2b57d27f-0b45-4b09-a178-6a0856fddb65.png",
    },
    gbp: {
      en: "https://static.percko.com/uploads/2b57d27f-0b45-4b09-a178-6a0856fddb65.png",
    },
    cad: {
      en: "https://static.percko.com/uploads/2b57d27f-0b45-4b09-a178-6a0856fddb65.png",
      fr: "https://static.percko.com/uploads/2b57d27f-0b45-4b09-a178-6a0856fddb65.png",
    },
    usd: {
      en: "https://static.percko.com/uploads/2b57d27f-0b45-4b09-a178-6a0856fddb65.png",
    },
  }

  return images[process.env.GATSBY_CURRENCY_TYPE][lang]
}

export const getStoreEnv = () => {
  return process && process.env ? process.env.GATSBY_ACTIVE_ENV : "general"
}

export const cartEstimateDeliveryTime = (productname, monthText, locale) => {
  let expectedDelivery1 = ""
  let expectedDelivery2 = ""
  let holidayEurArr = [
    "01-01-2026",
    "06-04-2026",
    "01-05-2026",
    "08-05-2026",
    "14-05-2026",
    "25-05-2026",
    "14-07-2026",
    "15-08-2026",
    "01-11-2026",
    "11-11-2026",
    "25-12-2026",
  ]
  let holidayGbpArr = [
    "01-01-2026",
    "03-04-2026",
    "06-04-2026",
    "04-05-2026",
    "25-05-2026",
    "31-08-2026",
    "25-12-2026",
    "26-12-2026",
    "28-12-2026",
  ]
  let holidayMatelasOreillerArr = [
    "31-12-2025",
    "01-01-2026",
    "02-01-2026",
    "06-04-2026",
    "01-05-2026",
    "08-05-2026",
    "14-05-2026",
    "25-05-2026",
    "14-07-2026",
    "15-08-2026",
    "01-11-2026",
    "11-11-2026",
    "25-12-2026",
  ]
  let holidaySurMatelasArr = [
    "31-12-2025",
    "01-01-2026",
    "02-01-2026",
    "05-01-2026",
    "06-04-2026",
    "01-05-2026",
    "08-05-2026",
    "14-05-2026",
    "25-05-2026",
    "14-07-2026",
    "15-08-2026",
    "01-11-2026",
    "11-11-2026",
    "25-12-2026",
  ]
  let holidaySommierArr = [
    "31-12-2025",
    "01-01-2026",
    "02-01-2026",
    "06-04-2026",
    "01-05-2026",
    "08-05-2026",
    "14-05-2026",
    "25-05-2026",
    "14-07-2026",
    "15-08-2026",
    "01-11-2026",
    "11-11-2026",
    "25-12-2026",
  ]

  let storeUrl = getStoreEnv()

  moment.updateLocale("us", {
    holidays:
      productname === "Matelas" ||
      productname === "matelas" ||
      productname === "1 Matelas + Oreiller" ||
      productname === "Matelas Mousse" ||
      productname === "matelas mousse" ||
      productname === "1 Matelas Mousse + Oreiller" ||
      productname === "Matelas signature" ||
      productname === "SommierMatelas" ||
      productname === "matelasHybrideFirstDeliveryDate" ||
      productname === "matelasMousseFirstDeliveryDate" ||
      productname === "matelasSignatureFirstDeliveryDate" ||
      productname === "matelasHybrideSecondDeliveryDate" ||
      productname === "matelasMousseSecondDeliveryDate" ||
      productname === "matelasSignatureSecondDeliveryDate" ||
      productname === "Oreiller" ||
      productname === "oreiller" ||
      productname === "Oreiller dorsal+" ||
      productname === "Oreiller plat" ||
      productname === "Taie d'oreiller universel" ||
      productname === "Taie d'oreiller dorsal+" ||
      productname === "Taie d'oreiller plat" ||
      productname === "SommierOreiller"
        ? holidayMatelasOreillerArr
        : productname === "Sommier zoné - coffre - effet chêne blanchi" ||
          productname ===
            "Sommier zoné - coffre - hêtre bois massif avec tête de lit" ||
          productname ===
            "Sommier zoné - coffre - chêne bois massif avec tête de lit" ||
          productname ===
            "Sommier zoné - coffre - hêtre bois massif sans tête de lit" ||
          productname ===
            "Sommier zoné - coffre - chêne bois massif avec tête de lit" ||
          productname === "Sommier Coffre bois massif chêne sans tête" ||
          productname === "Sommier Coffre bois massif hêtre sans tête" ||
          productname === "Sommier Original" ||
          productname === "Sommier Bois Massif" ||
          productname === "Sommier zoné - électrique" ||
          productname === "Sommier zoné - original tapissier" ||
          productname === "sommier" ||
          productname === "SommierCoffre" ||
          productname === "SommierHetreCoffre" ||
          productname === "SommierCheneCoffre" ||
          productname === "SommierHetreSansCoffre" ||
          productname === "SommierCheneSansCoffre" ||
          productname === "SommierOriginal" ||
          productname === "SommierBoisMassif" ||
          productname === "SommierElectric" ||
          productname === "SommierTapissier"
        ? holidaySommierArr
        : productname === "Surmatelas" || productname === "surmatelas"
        ? holidaySurMatelasArr
        : storeUrl === "gbp"
        ? holidayGbpArr
        : holidayEurArr,
    holidayFormat: "DD-MM-YYYY",
    workingWeekdays: [1, 2, 3, 4, 5],
  })

  if (storeUrl === "gbp") {
    expectedDelivery1 = moment().businessAdd(2)
    expectedDelivery2 = moment().businessAdd(5)
  } else if (storeUrl === "cad" || storeUrl === "usd") {
    expectedDelivery1 = moment().businessAdd(15)
    expectedDelivery2 = moment().businessAdd(20)
  } else {
    if (locale !== "fr") {
      expectedDelivery1 = moment().businessAdd(4)
      expectedDelivery2 = moment().businessAdd(9)
    } else {
      expectedDelivery1 = moment().businessAdd(2)
      expectedDelivery2 = moment().businessAdd(4)
    }
  }

  if (
    productname === "Oreiller" ||
    productname === "oreiller" ||
    productname === "Oreiller dorsal+" ||
    productname === "Oreiller plat" ||
    productname === "Taie d'oreiller universel" ||
    productname === "Taie d'oreiller dorsal+" ||
    productname === "Taie d'oreiller plat" ||
    productname === "SommierOreiller" ||
    productname === "Surmatelas" ||
    productname === "surmatelas" ||
    productname === "chaise" ||
    productname === "Chaise ergonomique"
  ) {
    expectedDelivery1 = moment().businessAdd(3)
    expectedDelivery2 = moment().businessAdd(5)
  }

  if (
    productname === "1 Matelas + Oreiller" ||
    productname === "Matelas" ||
    productname === "matelas" ||
    productname === "1 Matelas Mousse + Oreiller" ||
    productname === "Matelas Mousse" ||
    productname === "matelas mousse" ||
    productname === "Matelas signature" ||
    productname === "SommierMatelas"
  ) {
    expectedDelivery1 = moment().businessAdd(3)
    expectedDelivery2 = moment().businessAdd(10)
  }

  if (
    productname === "matelasHybrideFirstDeliveryDate" ||
    productname === "matelasMousseFirstDeliveryDate" ||
    productname === "matelasSignatureFirstDeliveryDate"
  ) {
    expectedDelivery1 = moment().businessAdd(3)
    expectedDelivery2 = moment().businessAdd(6)
  }

  if (
    productname === "matelasHybrideSecondDeliveryDate" ||
    productname === "matelasMousseSecondDeliveryDate" ||
    productname === "matelasSignatureSecondDeliveryDate"
  ) {
    expectedDelivery1 = moment().businessAdd(4)
    expectedDelivery2 = moment().businessAdd(10)
  }

  if (
    productname === "Sommier zoné - coffre - effet chêne blanchi" ||
    productname ===
      "Sommier zoné - coffre - hêtre bois massif avec tête de lit" ||
    productname ===
      "Sommier zoné - coffre - chêne bois massif avec tête de lit" ||
    productname ===
      "Sommier zoné - coffre - hêtre bois massif sans tête de lit" ||
    productname ===
      "Sommier zoné - coffre - chêne bois massif avec tête de lit" ||
    productname === "Sommier Coffre bois massif chêne sans tête" ||
    productname === "Sommier Coffre bois massif hêtre sans tête" ||
    productname === "Sommier Original" ||
    productname === "Sommier Bois Massif" ||
    productname === "Sommier zoné - électrique" ||
    productname === "Sommier zoné - original tapissier" ||
    productname === "sommier" ||
    productname === "SommierCoffre" ||
    productname === "SommierHetreCoffre" ||
    productname === "SommierCheneCoffre" ||
    productname === "SommierHetreSansCoffre" ||
    productname === "SommierCheneSansCoffre" ||
    productname === "SommierOriginal" ||
    productname === "SommierBoisMassif" ||
    productname === "SommierElectric" ||
    productname === "SommierTapissier"
  ) {
    expectedDelivery1 = moment().businessAdd(6)
    expectedDelivery2 = moment().businessAdd(10)
  }

  let expectedDeliveryDate1 = expectedDelivery1.format("D")
  let expectedDeliveryDate2 = expectedDelivery2.format("D")

  if (expectedDeliveryDate1 === 1) expectedDeliveryDate1 = "1er"

  if (expectedDeliveryDate2 === 1) expectedDeliveryDate2 = "1er"

  let estimateDeliveryArr = {
    FirstDeliveryDate:
      expectedDeliveryDate1 +
      `${
        monthText.month[Number(expectedDelivery1.format("MM")) - 1] !==
        monthText.month[Number(expectedDelivery2.format("MM")) - 1]
          ? " " + monthText.month[Number(expectedDelivery1.format("MM")) - 1]
          : ""
      }`,
    SecondDeliveryDate:
      expectedDeliveryDate2 +
      " " +
      monthText.month[Number(expectedDelivery2.format("MM")) - 1],
  }

  return estimateDeliveryArr
}

export const cartEstimateDeliveryText = (
  productname,
  monthText,
  locale,
  size,
  gender,
  color,
  collar
) => {
  const DELIVERY_TEXT_MAP = {
    gbp: {
      default:
        "Estimated delivery between FirstDeliveryDate and SecondDeliveryDate for the United Kingdom",
    },
    usd: {
      default:
        "Estimated delivery between FirstDeliveryDate and SecondDeliveryDate for the USA",
    },
    cad: {
      en: "Estimated delivery between FirstDeliveryDate and SecondDeliveryDate for Canada",
      default:
        "Livraison estimée entre le FirstDeliveryDate et le SecondDeliveryDate au Canada",
    },
    eur: {
      es: "Entrega estimada entre FirstDeliveryDate y SecondDeliveryDate en Europa",
      de: "Geschätzte Lieferung zwischen FirstDeliveryDate und SecondDeliveryDate in Europa",
      en: "Estimated delivery between FirstDeliveryDate and SecondDeliveryDate for Europe",
      default:
        "Livraison estimée entre le FirstDeliveryDate et le SecondDeliveryDate en France",
    },
  }

  let storeUrl = getStoreEnv()

  const region = ["gbp", "usd", "cad"].includes(storeUrl) ? storeUrl : "eur"

  let deliveryDateString =
    DELIVERY_TEXT_MAP[region][locale] || DELIVERY_TEXT_MAP[region].default

  let deliveryDate = cartEstimateDeliveryTime(productname, monthText, locale)

  if (collar && collar.includes("tshirt+discret")) {
    collar = collar.split("+").slice(-1)[0]
    if (collar.length > 0) {
      collar = collar.charAt(0).toUpperCase() + collar.slice(1)
    }
  }

  if (
    productname === "T-SHIRT DISCRET - FEMME" &&
    color === "Rose poudré" &&
    collar === "Rond" &&
    size === "H2.P3"
  ) {
    deliveryDateString =
      "Forte demande ! Livraison estimée entre le 24 et le 29 avril en France."
  }

  if (
    productname === "TshirtDiscret" &&
    gender === "Female" &&
    color === "Rose poudré" &&
    collar === "Rond" &&
    size === "H2.P3"
  ) {
    deliveryDateString =
      "Forte demande ! Livraison estimée entre le 24 et le 29 avril en France. Le <a href='/eur/shop/solutions-textiles/tshirt-discret/?Gender=Female&Collar=V&Color=Rose+poudr%C3%A9&Offer=Seul&Size=" +
      size +
      "'>modèle en col V</a> est disponible."
  }

  // if (
  //   productname === "T-SHIRT DISCRET - HOMME" &&
  //   collar === "V" &&
  //   color === "Gris" &&
  //   (size === "H1.P4" || size === "H2.P3")
  // ) {
  //   deliveryDateString =
  //     "Forte demande ! Livraison estimée entre le 17 et le 22 avril en France."
  // }

  // if (
  //   productname === "TshirtDiscret" &&
  //   gender === "Male" &&
  //   collar === "V" &&
  //   color === "Gris" &&
  //   size === "H1.P4"
  // ) {
  //   deliveryDateString =
  //     "Forte demande ! Livraison estimée entre le 17 et le 22 avril en France. Le <a href='/eur/shop/solutions-textiles/tshirt-discret/?Gender=Male&Collar=V&Color=Sable&Offer=Seul&Size=" +
  //     size +
  //     "'>modèle en sable</a> est disponible."
  // }

  // if (
  //   productname === "TshirtDiscret" &&
  //   gender === "Male" &&
  //   collar === "V" &&
  //   color === "Gris" &&
  //   size === "H2.P3"
  // ) {
  //   deliveryDateString =
  //     "Forte demande ! Livraison estimée entre le 17 et le 22 avril en France. Le <a href='/eur/shop/solutions-textiles/tshirt-discret/?Gender=Male&Collar=V&Color=Noir&Offer=Seul&Size=" +
  //     size +
  //     "'>modèle en noir</a> est disponible."
  // }

  if (
    productname === "T-SHIRT DISCRET - HOMME" &&
    collar === "V" &&
    color === "Gris" &&
    size === "H1.P2"
  ) {
    deliveryDateString =
      "Forte demande ! Livraison estimée entre le 24 et le 29 avril en France."
  }

  if (
    productname === "TshirtDiscret" &&
    gender === "Male" &&
    collar === "V" &&
    color === "Gris" &&
    size === "H1.P2"
  ) {
    deliveryDateString =
      "Forte demande ! Livraison estimée entre le 24 et le 29 avril en France. Le <a href='/eur/shop/solutions-textiles/tshirt-discret/?Gender=Male&Collar=V&Color=Noir&Offer=Seul&Size=" +
      size +
      "'>modèle en noir</a> est disponible."
  }

  if (
    productname === "T-SHIRT DISCRET - HOMME" &&
    collar === "V" &&
    color === "Noir" &&
    (size === "H1.P4" || size === "H2.P4")
  ) {
    deliveryDateString =
      "Forte demande ! Livraison estimée entre le 24 et le 29 avril en France."
  }

  if (
    productname === "TshirtDiscret" &&
    gender === "Male" &&
    collar === "V" &&
    color === "Noir" &&
    (size === "H1.P4" || size === "H2.P4")
  ) {
    deliveryDateString =
      "Forte demande ! Livraison estimée entre le 24 et le 29 avril en France. Le <a href='/eur/shop/solutions-textiles/tshirt-discret/?Gender=Male&Collar=V&Color=Gris&Offer=Seul&Size=" +
      size +
      "'>modèle en gris</a> est disponible."
  }

  // if (
  //   (productname === "GILET PRATIQUE - HOMME" ||
  //     (productname === "TshirtGilet" && gender === "Male")) &&
  //   color === "Noir" &&
  //   (size === "S" || size === "M")
  // ) {
  //   deliveryDateString =
  //     "Forte demande ! Livraison estimée entre le 20 et le 24 mars en France."
  // }

  // if (
  //   (productname === "GILET PRATIQUE - FEMME" ||
  //     (productname === "TshirtGilet" && gender === "Female")) &&
  //   color === "Noir" &&
  //   (size === "S" || size === "M")
  // ) {
  //   deliveryDateString =
  //     "Forte demande ! Livraison estimée entre le 6 et le 10 mars en France."
  // }

  if (
    (productname === "T-SHIRT DE SPORT - HOMME" ||
      (productname === "TshirtSport" && gender === "Male")) &&
    color === "Noir" &&
    (size === "M" || size === "XXL")
  ) {
    deliveryDateString =
      "Forte demande ! Livraison estimée entre le 24 et le 29 avril en France."
  }

  if (
    (productname === "T-SHIRT DE SPORT - FEMME" ||
      (productname === "TshirtSport" && gender === "Female")) &&
    color === "Noir" &&
    size === "XL"
  ) {
    deliveryDateString =
      "Forte demande ! Livraison estimée entre le 24 et le 29 avril en France."
  }

  if (productname === "matelas") {
    deliveryDateString =
      "Livraison gratuite (standard) ou livraison à l’étage. Estimée entre le FirstDeliveryDate et le SecondDeliveryDate en France"
  }

  if (
    productname === "matelasHybrideFirstDeliveryDate" ||
    productname === "matelasMousseFirstDeliveryDate" ||
    productname === "matelasSignatureFirstDeliveryDate"
  ) {
    deliveryDateString =
      "Livraison gratuite entre le FirstDeliveryDate et le SecondDeliveryDate en France"
  }

  if (
    productname === "matelasHybrideSecondDeliveryDate" ||
    productname === "matelasMousseSecondDeliveryDate" ||
    productname === "matelasSignatureSecondDeliveryDate"
  ) {
    deliveryDateString =
      "Livraison à l’étage entre le FirstDeliveryDate et le SecondDeliveryDate en France"
  }

  if (
    productname === "SommierOriginal" ||
    productname === "SommierElectric" ||
    productname === "SommierBoisMassif" ||
    productname === "SommierHetreCoffre" ||
    productname === "SommierCheneCoffre" ||
    productname === "SommierHetreSansCoffre" ||
    productname === "SommierCheneSansCoffre" ||
    productname === "SommierCoffre" ||
    productname === "SommierTapissier"
  ) {
    deliveryDateString =
      "Livraison du sommier estimée entre le FirstDeliveryDate et le SecondDeliveryDate en France"
  }

  // if (productname === "Sommier Original" && size === "160x200cm") {
  //   deliveryDateString =
  //     "Forte demande ! Livraison estimée entre le 20 et le 24 avril en France"
  // }

  // if (productname === "SommierOriginal" && size === "160x200cm") {
  //   deliveryDateString =
  //     "Forte demande ! Livraison du sommier estimée entre le 20 et le 24 avril en France"
  // }

  // if (
  //   productname === "Sommier zoné - électrique" &&
  //   (size === "80x200cm" ||
  //     size === "90x200cm" ||
  //     size === "160x200cm" ||
  //     size === "180x200cm")
  // ) {
  //   deliveryDateString =
  //     "Forte demande ! Livraison estimée entre le 16 et le 20 mars en France"
  // }

  // if (
  //   productname === "SommierElectric" &&
  //   (size === "80x200cm" ||
  //     size === "90x200cm" ||
  //     size === "160x200cm" ||
  //     size === "180x200cm")
  // ) {
  //   deliveryDateString =
  //     "Forte demande ! Livraison du sommier estimée entre le 16 et le 20 mars en France"
  // }

  // if (
  //   productname === "Sommier zoné - original tapissier" &&
  //   size === "160x200cm"
  // ) {
  //   deliveryDateString =
  //     "Forte demande ! Livraison estimée entre le 20 et le 24 avril en France"
  // }

  // if (productname === "SommierTapissier" && size === "160x200cm") {
  //   deliveryDateString =
  //     "Forte demande ! Livraison du sommier estimée entre le 20 et le 24 avril en France"
  // }

  if (productname === "SommierMatelas") {
    deliveryDateString =
      "Livraison du matelas estimée entre le FirstDeliveryDate et le SecondDeliveryDate en France"
  }

  if (productname === "SommierOreiller") {
    deliveryDateString =
      "Livraison de l'oreiller estimée entre le FirstDeliveryDate et le SecondDeliveryDate en France"
  }

  // if (
  //   (productname === "Surmatelas" || productname === "surmatelas") &&
  //   size === "140x200cm"
  // ) {
  //   deliveryDateString = "Livraison estimée entre 15 et le 19 janvier en France"
  // }

  // if (productname === "chaise" || productname === "Chaise ergonomique") {
  //   deliveryDateString =
  //     "Forte demande ! Livraison prévue entre le 12 et le 17 février en France."
  // }

  // if (
  //   (productname === "SoutienGorge" || productname === "Soutien-gorge") &&
  //   size === "XL A-B"
  // ) {
  //   deliveryDateString =
  //     "Forte demande ! Livraison estimée entre le 24 et le 29 avril en France."
  // }

  if (
    productname === "E-carte cadeau" ||
    productname === "E-carte cadeau offerte" ||
    productname === "E-CARTE"
  ) {
    deliveryDateString = "Envoyée par mail"
  }

  deliveryDateString = deliveryDateString
    .replace("FirstDeliveryDate", deliveryDate.FirstDeliveryDate)
    .replace("SecondDeliveryDate", deliveryDate.SecondDeliveryDate)

  return deliveryDateString
}

export const getTotalTshirtQuantity = checkout => {
  let totalTshirtQuant = 0

  checkout.lineItems.forEach(item => {
    // if (item.title.includes("T-SHIRT") || item.title.includes("GILET")) {
    totalTshirtQuant = totalTshirtQuant + item.quantity
    // }
  })

  return totalTshirtQuant
}
